module.exports = __webpack_public_path__ + "img/per_object.44132b1b.png";